import React from 'react';
import { useEffect } from 'react';
import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';
import HomeHeaderComponent from '../common/header/homeheader/HomeHeaderComponent';

function InnerPageLayout(props) {
  useEffect(() => {
    const header = document.getElementById('myHeader');
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener('scroll', () => {
      if (window.pageYOffset > sticky) {
        header.classList.add('dashboard__sticky');
      } else {
        header.classList.remove('dashboard__sticky');
      }
    });
    return () => {
      window.removeEventListener('scroll', scrollCallBack);
    };
  }, []);

  return (
    <div>
      <header id="myHeader" className="dashboard__header">
        <HomeHeaderComponent />
      </header>
      <div className="inner-body-section">{props.children}</div>
      {/* <HomeFooterComponent /> */}
    </div>
  );
}

export default InnerPageLayout;
